var _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 16,
    viewBox: "0 0 145 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 137.646,
    height: 2.45139,
    rx: 1.22569,
    transform: "matrix(0.999999 -0.00129243 0.00858915 -0.999963 4.04471 7.45288)",
    fill: "#FFBF35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 144.015,
    height: 2.45139,
    rx: 1.22569,
    transform: "matrix(0.999999 -0.00129243 0.00858915 -0.999963 0.74942 11.4263)",
    fill: "#FFBF35"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLines);
export default __webpack_public_path__ + "static/media/yellowLines.00d57c2710c983b41df47ac09a315c88.svg";
export { ForwardRef as ReactComponent };